import LegalLayout from "@/components/LegalLayout";

const SECTIONS = [
  {
    heading: "Introduction",
    body: [
      "This Privacy Policy explains how Radio App Consultancy (\"we\", \"us\", \"our\") collects, uses, and protects your personal information when you use our website and software development services. By using our website or making a payment, you agree to the practices described here.",
    ],
  },
  {
    heading: "Information We Collect",
    body: [
      "Contact details you provide at checkout, such as your full name, email address, and phone number.",
      "Payment-related information required to process your order. Card and banking details are entered directly on our payment processors' secure pages and are never stored on our servers.",
      "Technical information such as your IP address, browser type, and device information, collected automatically to help secure transactions and prevent fraud.",
    ],
  },
  {
    heading: "How We Use Your Information",
    body: [
      "To process your one-time payment and deliver the software development/consultation service you requested.",
      "To send you receipts, order confirmations, and respond to your support requests.",
      "To protect against fraud and unauthorized transactions, and to keep records of your consent for the payment you authorized.",
    ],
  },
  {
    heading: "Payment Processing",
    body: [
      "Payments are processed securely by our third-party payment providers, Razorpay and PayPal. When you pay, your payment information is handled by these PCI-DSS compliant providers under their own privacy and security policies.",
      "We receive only limited transaction details (such as a payment ID and status) needed to confirm and fulfil your order.",
    ],
  },
  {
    heading: "Data Sharing",
    body: [
      "We do not sell or rent your personal information. We share information only with our payment processors and service providers strictly as needed to deliver your order, or where required by law.",
    ],
  },
  {
    heading: "Data Security & Retention",
    body: [
      "We use SSL/HTTPS encryption across our website and apply reasonable safeguards to protect your information. We retain order and consent records for as long as needed for accounting, legal, and dispute-resolution purposes.",
    ],
  },
  {
    heading: "Your Rights",
    body: [
      "You may request access to, correction of, or deletion of your personal information by contacting us. We will respond within a reasonable time, subject to any legal record-keeping obligations.",
    ],
  },
  {
    heading: "Cookies",
    body: [
      "Our website may use essential cookies to keep the site functioning and secure. We do not use cookies to sell your data to third parties.",
    ],
  },
  {
    heading: "Contact Us",
    body: [
      "If you have any questions about this Privacy Policy or your data, contact us at akarjagdev@gmail.com or call (864) 481-0776.",
    ],
  },
];

export default function Privacy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      updated="June 2026"
      intro="Your privacy matters to us. This policy explains what information we collect and how we use and protect it."
      sections={SECTIONS}
    />
  );
}
